import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import SideBar from "./Sidebar";
import { Topbar } from "./TopBar";
import { Footer } from "./Footer";
import StorefrontIcon from '@material-ui/icons/Storefront';
import CropLandscapeIcon from '@material-ui/icons/CropLandscape';
import PeopleIcon from '@material-ui/icons/People';
import SettingsIcon from '@material-ui/icons/Settings';
import { Alert } from "views/shareViews";
import { clearStorage } from "utils";
import { menuPoint } from "./breakpoints";
import { headerHeight, footerHeight } from "./shareParams";

const ADMIN = "admin";
//const SALES = "sales";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: headerHeight,
    height: '100%',
    [theme.breakpoints.up(menuPoint)]: {
      paddingTop: headerHeight
    },
  },
  footer : {
    // height: `calc(2em + ${headerHeight}px)`
    height: `2em`
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%',
    overflow: "auto"
  },
  wrapper: {
    minHeight: "100%",
    // margin: `0 auto calc(-2em - ${headerHeight}px)`
    margin: `0 auto -${footerHeight}`
  },
  topBar: {
    height: "0px"
  },
  padding : {
    padding : "16px"
  }
}));

export const Main = (props) => {
  const { children, history } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up(menuPoint), {
    defaultMatches: true
  });
  const [openSidebar, setOpenSidebar] = useState(false);

  const handleLogout = () => {
    Alert({
      text: "确定要注销该账户吗?",
      handleSubmit: () => {
        clearStorage();
        history.push('/sign-in');
      }
    })
  };

  const handleSidebarClick = () => {
    setOpenSidebar(!openSidebar);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;
  const role = localStorage.getItem("role");
  const username = localStorage.getItem("name");
  const pages = role === ADMIN ? [
    {
      title: '周报列表',
      href: '/weekly-report-list',
      icon: <StorefrontIcon />
    },
    {
      title: '周报统计',
      href: '/weekly-report-statistics',
      icon: <CropLandscapeIcon />
    },
    {
      title: '人员设置',
      href: '/user-manage',
      icon: <PeopleIcon />
    },
    {
      title: '系统配置',
      href: '/sysconfig',
      icon: <SettingsIcon />
    }
  ] : [
    {
      title: '周报列表',
      href: '/weekly-report-list',
      icon: <StorefrontIcon />
    },
  ];

  return (
    <div className={clsx({
      [classes.root]: true,
      [classes.shiftContent]: isDesktop
    })}>
      <Topbar onSidebarOpen={handleSidebarClick} onLogout={username === ADMIN ? handleLogout : void 0} 
      // className={clsx({
      //   [classes.topBar]: !isDesktop
      // })}
      />
      <SideBar pages={pages} onClose={handleSidebarClose} open={shouldOpenSidebar} variant={isDesktop ? 'persistent' : 'temporary'} />
      <main className={classes.content}>
        <div className={classes.wrapper}>
          <div className={classes.padding}>
            {children}
          </div>
          <div className={classes.footer}></div>
        </div>
        <Footer />
      </main>
    </div>
  );
};
